<template>
  <div>
    <h1 class="sr-only">{{ surveyTitle }}</h1>
    <div id="surveyContainer"></div>
  </div>
</template>

<script>
import { city } from "@/../env.js";

const surveyJson = require("@/libs/survey.json");

export default {
  name: "Survey",
  data() {
    return {
      survey: null,
      surveyTitle: `${city.name}政府衛生局「整合式篩檢-全民健檢」問卷`,
      name: "",
      id: "",
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.name = urlParams.get("aka_name") || urlParams.get("name") || "";
    this.id = urlParams.get("aka_id") || urlParams.get("id") || "";
  },
  mounted() {
    // 引入CSS
    const link = document.createElement("link");
    link.href = "/vendor/survey-core/survey-core.min.css";
    link.type = "text/css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // 引入JS
    this.loadScript("/vendor/survey-core/survey.core.min.js")

      .then(() =>
        this.loadScript(
          "/vendor/survey-core/i18n/traditional-chinese.js"
        )
      )
      .then(() =>
        this.loadScript("/vendor/survey-js-ui/survey-js-ui.min.js")
      )
      .then(async () => {
        surveyJson.title = this.surveyTitle;
        this.survey = new Survey.Model(surveyJson);
        this.survey.locale = "zh-tw";
        // survey.applyTheme(SurveyTheme.FlatLight);

        await this.initSurveyData();
        // this.clearPageAnswers([1]);

        this.survey.onCurrentPageChanged.add((sender, options) => {
          const currentPageIndex = sender.currentPageNo;
          if (currentPageIndex > 0) {
            sender.showProgressBar = "top";
          } else {
            sender.showProgressBar = "none";
          }
        });

        this.survey.render(document.getElementById("surveyContainer"));
        this.survey.onComplete.add(this.surveyComplete);
        this.survey.onValueChanged.add((sender, options) => {
          if (options.name === "身分證字號") {
            this.setGender(this.survey);
          }
          // 確保 store 中存儲的是原始數據
          this.survey.data = sender.data;
          this.$store.commit("setState", { surveyData: this.survey.data });
        });
      });
  },
  methods: {
    async initSurveyData() {
      // this.survey.data = this.$store.state.surveyData;
      this.$set(this.survey, "data", this.$store.state.surveyData);

      if (this.id && this.id != this.survey.data.身分證字號) {
        this.survey.data = {};
      }
      if (this.id) {
        // this.survey.data.身分證字號 = this.id;
        // this.$set(this.survey.data, "身分證字號", this.id);
        this.survey.setValue("身分證字號", this.id);
      }
      if (this.name) {
        this.survey.setValue("姓名", this.name);
        // this.survey.data.姓名 = this.name;
      }
      if (this.id && this.name) {
        let { data } = await this.axios.get(`/survey/${this.id}/${this.name}`);
        if (data && data.外部問卷) {
          const processedData = this.processStoredData(data.外部問卷);
          this.survey.data = processedData;
        }
      }
      this.setGender(this.survey);
    },
    async surveyComplete(survey) {
      const processedData = this.processDataForStorage(survey.data);
      let id = processedData.身分證字號;
      let payload = {
        data: JSON.stringify(processedData),
      };
      await this.axios.post(`/survey/${id}`, payload);
      this.$toast.success("已成功送出，感謝您的填寫！");
      this.$router.push("/");
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.type = "text/javascript";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    setGender() {
      let questionToHide = this.survey.getQuestionByName(
        "23.(女性填答)當您用力咳嗽時，是否有漏尿情形?"
      );

      if (this.getGender(this.survey.data.身分證字號) == "男") {
        questionToHide.visible = false;
      } else {
        questionToHide.visible = true;
      }
    },
    getGender(value) {
      if (!value) return null;

      switch (value[1]) {
        case "1":
        case "A":
        case "C":
          return "男";
          break;
        case "2":
        case "B":
        case "D":
          return "女";
        default:
          return null;
          break;
      }
    },
    processStoredData(data) {
      const result = { ...data };
      const checkboxQuestions = this.findCheckboxQuestions();

      for (const name of checkboxQuestions) {
        if (typeof result[name] === "string" && result[name]) {
          result[name] = result[name].split(",");
        }
      }
      return result;
    },
    processDataForStorage(data) {
      const result = { ...data };
      const checkboxQuestions = this.findCheckboxQuestions();

      for (const name of checkboxQuestions) {
        if (Array.isArray(result[name])) {
          result[name] = result[name].join(",");
        }
      }
      return result;
    },
    findCheckboxQuestions() {
      const checkboxQuestions = [];
      for (const page of surveyJson.pages) {
        for (const element of page.elements) {
          if (element.type === "checkbox" && element.name) {
            checkboxQuestions.push(element.name);
          }
        }
      }
      return checkboxQuestions;
    },
    // 清空指定頁面所有題目的答案
    clearPageAnswers(pageNumbers) {
      if (!this.survey) return;

      // 確保輸入是數組
      if (!Array.isArray(pageNumbers)) {
        pageNumbers = [pageNumbers];
      }

      // 過濾出有效的頁碼
      const validPageNumbers = pageNumbers.filter((pageNumber) => {
        if (pageNumber < 0 || pageNumber >= this.survey.pages.length) {
          console.error(
            `無效的頁碼: ${pageNumber}，頁碼範圍應為 0-${
              this.survey.pages.length - 1
            }`
          );
          return false;
        }
        return true;
      });

      // 清空所有指定頁面的問題答案
      validPageNumbers.forEach((pageNumber) => {
        const page = this.survey.pages[pageNumber];
        page.questions.forEach((question) => {
          this.survey.setValue(question.name, null);
        });
        console.log(`已清空第 ${pageNumber + 1} 頁的所有答案`);
      });

      if (validPageNumbers.length > 0) {
        // 更新 store 中的數據
        this.$store.commit("setState", { surveyData: this.survey.data });
      }
    },
  },
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>

<style scoped lang="scss">
::v-deep .page-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #23a58b;
}
</style>
